import AddButton from "../../components/buttons/AddButton";
import Dashboard from "../../components/Dashboard";
import Table, { Badge } from "../../components/Table";
import { MdPersonAddAlt1 } from "react-icons/md";

import AddClinic from "../../components/forms/AddClinic";
import { useForm } from "../../context/formContext";
import { HttpClient } from "../../Redux/controllers/HttpClient";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ClinicModal from "../../components/Modals/ClinicModal";
import { useModal } from "../../context/modalContext";
import { Spinner } from "@material-tailwind/react";
import {
  // getOrganizationTableData,
  organizationTableHeadData,
} from "../../constants/data/organizationData";
import AddOrganization from "../../components/forms/AddOrganization";
import OrganizationModal from "../../components/Modals/OrganizationModal";
import Edit from "../../components/buttons/Edit";
import Delete from "../../components/buttons/DeleteButton";
import DeleteUserModal from "../../components/Modals/DeleteUserModal";
import toast from "react-hot-toast";
import Toggle from "react-toggle";

const OrganizationPage = () => {
  const { showForm, openForm, closeForm } = useForm();
  const {
    showEditModal,
    showModal,
    openModal,
    closeModal,
    closeEditModal,
    openDeleteModal,
    closeDeleteModal,
    showDeleteModal,
  } = useModal();
  const [showSpin, setShowSpin] = useState(false);
  const { token } = useSelector((state) => state.user);
  const [orgTableData, setOrgTableData] = useState([]);

  const fetchData = async () => {
    setShowSpin(true);
    try {
      const { data } = await HttpClient.apiCaller(
        "admin/user-list?role=organization",
        "GET",
        null,
        token,
        null
      );
      // console.log("//////////////////", data.user);
      setOrgTableData(data.user);
    } catch (error) {
      console.log(error);
    } finally {
      setShowSpin(false);
    }
  };
  useEffect(() => {
    fetchData();

    return () => {};
  }, [closeForm, closeEditModal]);

  const handleToggleUpload = async (userId, isAllowed) => {
    try {
      await HttpClient.apiCaller(
        "toggle-manual-upload",
        "PUT",
        { userId, isAllowed: !isAllowed },
        token
      );
      toast.success(
        `Manual upload ${!isAllowed ? "enabled" : "disabled"} successfully`
      );
      fetchData();
    } catch (error) {
      toast.error(
        error.response?.data?.error || "Error updating upload access"
      );
    }
  };
  const getOrganizationTableData = (dataSet) => {
    const tableData = dataSet.map((item, idx) => {
      return {
        no: idx + 1,
        uid: item?.uid,
        organization: item?.organizationName,
        employecode: item?.employer_code,
        email: item?.email,
        mobile: item?.mobile_number,
        upload: (
          <Toggle
            checked={item?.isManualUploadAllowed || false}
            onChange={() =>
              handleToggleUpload(item._id, item.isManualUploadAllowed)
            }
            className="custom-toggle"
          />
        ),
        // status: <Badge status={item?.status} />,
        action: (
          <div className="flex gap-3">
            <Edit user={item} />
            <Delete user={item} />
          </div>
        ),
      };
    });
    return tableData;
  };
  return (
    <Dashboard>
      {showForm ? (
        <AddOrganization onClose={closeForm} />
      ) : (
        <>
          {" "}
          <div className="flex xs:flex-col-reverse xs:gap-2 sm:flex-row sm:items-center sm:justify-between mb-5">
            <div>
              <p className="poppins-medium  leading-[21px]  text-gray-700 mb-2">
                List of Organizations
              </p>
              <p className="poppins-regular text-xs text-[#B5B5C3] ">
                {orgTableData?.length} available Organizations
              </p>
            </div>
            {/*  */}
            <AddButton
              onClick={openForm}
              buttonName={"Add New Organization"}
              icon={<MdPersonAddAlt1 className="size-5" />}
            />
          </div>
          {/*  table */}
          {showSpin ? (
            <div className="w-full mt-20 flex items-center justify-center">
              <Spinner className="h-12 w-12" />{" "}
            </div>
          ) : (
            <Table
              tableData={getOrganizationTableData(orgTableData)}
              tableHeadData={organizationTableHeadData}
            />
          )}
        </>
      )}
      {/*Edit modal */}
      {showEditModal ? (
        <OrganizationModal edit={true} onClose={closeEditModal} />
      ) : (
        <></>
      )}
      {/* delete modal */}
      {showDeleteModal && <DeleteUserModal onClose={closeDeleteModal} />}
    </Dashboard>
  );
};

export default OrganizationPage;
